import ServiceCRUD from '../../../../services/ServiceCRUDFLEXUC';
import { apiUc } from '../../../../http';

class Service extends ServiceCRUD {
  constructor() {
    super('/api/qa/assessment');
  }

  getAssessmentAnalytics(
    { dateBegin, dateEnd, user, size, author, reportType, exportFile, queue },
    pagina
  ) {
    const path = reportType === 2 ? `/api/qa/assessment/average` : this.path;

    return apiUc.get(path, {
      params: {
        dateBegin,
        dateEnd,
        user: user,
        author: author,
        queue: queue,
        limit: size,
        offset: size * (pagina - 1),
        exportFile: exportFile
      }
    });
  }

  getAssessmentAnswers(id) {
    return apiUc.get(`${this.path}/${id}`);
  }

  getAssessmentsByCdrReport(id) {
    return apiUc.get(`${this.path}s/by_cdr_report/${id}`);
  }

  getAssessmentFile({
    dateBegin,
    dateEnd,
    user,
    author,
    reportType,
    exportType,
    queue
  }) {
    return apiUc.get('/api/qa/assessment/export/file', {
      params: {
        dateBegin,
        dateEnd,
        user: user,
        author: author,
        queue: queue,
        reportType: reportType,
        exportType: exportType
      },
      responseType: 'arraybuffer'
    });
  }

  postAssessmentFeedback(data) {
    return apiUc.post(`${this.path}/feedback`, data);
  }
}

export default new Service();
